import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        textAlign: "center",
        color: "#ffffff",
        overflow: "hidden",
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${process.env.REACT_APP_BG_IMAGE_URL})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(60%)",
          zIndex: -1,
        }}
      />

      {/* Content Container */}
      <Container>
        {/* Animated Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" fontWeight="bold">
            Intelligent Code Snippet Organizer
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, opacity: 0.9 }}>
            Save, organize, and enhance your code effortlessly with AI.
          </Typography>
        </motion.div>

        {/* Buttons with animation */}
        <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 2 }}>
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => navigate("/login")}
              sx={{ borderRadius: "8px", px: 4 }}
            >
              Login
            </Button>
          </motion.div>

          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
            <Button
              variant="outlined"
              color="secondary"
              size="large"
              onClick={() => navigate("/register")}
              sx={{
                borderRadius: "8px",
                px: 4,
                color: "white",
                borderColor: "white",
              }}
            >
              Register
            </Button>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;
